import React from "react";

export const GallerySection: React.FC = () => {
  const images = [
    {
      imgSrc: "images/work-1.jpg",
      category: "Šišanje",
      author: "Bobana",
    },
    {
      imgSrc: "images/work-2.jpg",
      category: "Stilizovanje brade",
      author: "Ognjen",
    },
    {
      imgSrc: "images/work-3.jpg",
      category: "Šišanje i stilizovanje brade",
      author: "Bobana",
    },
    {
      imgSrc: "images/work-4.jpg",
      category: "Šišanje i stilizovanje brade",
      author: "Ognjen",
    },
    {
      imgSrc: "images/work-5.jpg",
      category: "Stilizovanje brade",
      author: "Bobana",
    },
    {
      imgSrc: "images/work-6.jpg",
      category: "Šišanje",
      author: "Ognjen",
    },
    {
      imgSrc: "images/work-7.jpg",
      category: "Šišanje",
      author: "Bobana",
    },
    {
      imgSrc: "images/work-8.jpg",
      category: "Stilizovanje brade",
      author: "Ognjen",
    },
  ];

  return (
    <section id="gallery" className="ftco-section" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>
    	<div className="container">
    		<div className="row no-gutters justify-content-center mb-5 pb-2">
          <div className="col-md-6 text-center heading-section">
          	<span className="subheading">galerija</span>
            <h2 className="mb-4">Vaša inspiracija za savršenu frizuru!</h2>
            <p style={{ fontSize: '20px' }}>
              Pogledajte našu kolekciju fotografija – od klasičnih do modernih stilova, kod nas ćete pronaći izgled koji savršeno odgovara vašoj ličnosti.
            </p>
          </div>
        </div>
    	</div>
			<div className="container-fluid p-0">
    		<div className="row no-gutters">
				{images.map((image, index) => (
					<div className="col-md-6 col-lg-3" key={index}>
						<div className="project">
							<img
								src={image.imgSrc}
								className="img-fluid"
								alt={`${image.category} by ${image.author}`}
							/>
							<div className="text">
								<span>{image.author}</span>
								<h3>
									{image.category}
								</h3>
							</div>
						</div>
					</div>
				))}
    		</div>
    	</div>
		</section>
  );
};
